import React from 'react';
import * as FlatColor from 'react-icons/fc';
import { FcBrokenLink } from 'react-icons/fc';

export default function GenerateIcon(icon, open = false) {
  if (icon == null) return <FcBrokenLink size={22} />;

  // console.log("this is icon object and type", icon, typeof icon)
  const iconFile =
    typeof icon === 'object' && icon.iconFile && icon.iconFile.length > 0
      ? icon.iconFile
      : null;
  if (iconFile != null) {
    const mediaFolder = '/media';
    // console.log('this is icon file name 📂', iconFile);
    return (
      <img
        alt='This is custom icon.'
        className={open ? 'active-section' : ''}
        src={`${mediaFolder}/${iconFile}`}
        style={{
          // marginTop: 20,
          display: 'inline-block',
          width: '100%',
          maxWidth: 26,
          height: '100%',
          maxHeight: 26,
          minWidth: 24,
          minHeight: 24
        }}
      />
    );
  } else {
    const iconName =
      typeof icon === 'string' || icon instanceof String
        ? icon
        : typeof icon === 'object' && icon?.name.length != 0
        ? icon.name
        : 'FcBrokenLink';
    // console.log("this is icon name😮", iconName)
    const Icon = FlatColor[iconName] || <FcBrokenLink size={22} />;
    // || HeroIcons[iconName] || HeroIcons2[iconName]
    return <Icon size={22} />;
  }
}
